import { render, staticRenderFns } from "./InformationRoleModel.vue?vue&type=template&id=6c11e4af"
import script from "./InformationRoleModel.vue?vue&type=script&lang=js"
export * from "./InformationRoleModel.vue?vue&type=script&lang=js"
import style0 from "./InformationRoleModel.vue?vue&type=style&index=0&id=6c11e4af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports